module.exports = __webpack_public_path__ + "static/media/o-que-preciso-para-alugar.c3ae027f.webp";